<template>
  <div class="col-auto">
    <model-table
      title="Prices"
      :collection="membershipType.membershipUserTypes"
      :submodel="true"
      :columns="[
        { name: 'userClass', field: row => row.userClass.name },
        { field: 'monthlyRate', component: 'money-hundredths', hide: currentCircuit.membershipRateDisplayPeriod !== MEMBERSHIP_RATE_DISPLAY_PERIODS.MONTHLY },
        { label: 'Additional User Monthly Rate', field: 'additionalMonthlyRate', component: 'money-hundredths', hide: currentCircuit.membershipRateDisplayPeriod !== MEMBERSHIP_RATE_DISPLAY_PERIODS.MONTHLY },
        { field: 'yearlyRate', component: 'money', hide: currentCircuit.membershipRateDisplayPeriod !== MEMBERSHIP_RATE_DISPLAY_PERIODS.YEARLY },
        { label: 'Additional User Yearly Rate', field: 'additionalYearlyRate', component: 'money', hide: currentCircuit.membershipRateDisplayPeriod !== MEMBERSHIP_RATE_DISPLAY_PERIODS.YEARLY },
        { name: 'actions', align: 'right' }
      ]"
      @add="$refs.dialog.show()"
    >
      <membership-user-type-form :submodel="true" />
    </model-table>
    <select-membership-user-types-dialog
      ref="dialog"
      :membership-type="membershipType"
    />
  </div>
</template>

<script>

import { MEMBERSHIP_RATE_DISPLAY_PERIODS } from 'src/models/circuit/Circuit'
import MembershipType from 'src/models/membership-type/MembershipType'
import ModelTable from 'src/modules/admin/components/ModelTable'
import MembershipUserTypeForm from 'src/modules/admin/membership-type/MembershipUserTypeForm'
import SelectMembershipUserTypesDialog from 'src/modules/admin/membership-type/SelectMembershipUserTypesDialog'

export default {
  name: 'ItemModifierSetTable',
  components: {
    ModelTable,
    SelectMembershipUserTypesDialog,
    MembershipUserTypeForm
  },
  props: {
    membershipType: {
      type: MembershipType,
      required: true
    }
  },
  configuration: ['currentCircuit'],
  created () {
    _.extend(this, { MEMBERSHIP_RATE_DISPLAY_PERIODS })
  }
}
</script>
